export const objectTypePredicate =
	(settings?: { exclude?: boolean; names?: string[] }) =>
	({ name }: { name: string }) =>
		settings?.exclude
			? !settings?.names?.map(name => name.toLowerCase())?.includes(name.toLowerCase())
			: settings?.names?.map(name => name.toLowerCase())?.includes(name.toLowerCase()) ?? true
